module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "OldFlames_epub-3.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "CT-new-page para-style-override-5"
  }, [_c('span', {
    staticClass: "Section-Symbol char-style-override-8"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("opyright © 1996 by John Lawton")])]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_c('span', [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any elec")]), _vm._v("tronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only author­ized electronic editions, and do not participate in or encourage electronic piracy of copy­righted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions%40groveatlantic.com?subject="
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("First published in Great Britain in 1996 by Weidenfeld & Nicolson, London, England")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("The extract from his introduction to "), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Philby: The Spy Who Betrayed a Generation ")]), _vm._v("is quoted by permission of John le Carré.")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("The extract from his interview with Kim Philby is quoted by permission of Murray Sayle.")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("The extract from Graham Greene’s introduction to Kim Philby’s "), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("My")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Silent War ")]), _vm._v("is quoted by permission of David Higham Associates Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("first american edition")])]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Lawton, John, 1949–")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("Old flames / John Lawton.")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("ISBN 978-0-8021-9949-2")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("1. Khrushchev, Nikita Sergeyevich, 1894–1971—Fiction. 2. Bulganin, Nikolay Aleksandrovich, 1895–1975—Fiction. 3. Russians—Great Britain—Fiction. 4. Intelligence officers—Fiction. 5. Visits of state—Fiction. 6. Cold War—Fiction. 7. England—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("PR6062.A938 043 2003")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("823'.914—dc21")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-7"
  }, [_vm._v("2002028025")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-6"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("841 Broadway")]), _vm._v(" "), _c('p', {
    staticClass: "CR"
  }, [_vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-8"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-8"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.groveatlantic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "CR para-style-override-8"
  }, [_vm._v("12 13 14 15 16 10 9 8 7 6 5 4 3 2 1")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc542afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OldFlames_epub3.vue
// module id = 69
// module chunks = 0